import {
  Button,
  Flex,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
} from "antd-mobile";
import { Fragment, useCallback, useEffect, useState } from "react";
import { bottomBtnStyle } from "..";
import instance from "../../../../util/axios";
import { formatRoundNumber } from "../util";
import { ProductInfo } from "./StepTwo";

interface ProductService {
  text: string;
  spec: string;
  quantity: string;
  id: string[];
  editable: boolean;
}
export interface OrderService {
  name: string;
  code: number;
  productId: string;
  productCategory: string;
  serviceData: ProductService[];
}
interface fourProps {
  onCancel?: () => void;
  onOk?: (data: OrderService[]) => void;
  productData: ProductInfo[];
  defaultValues?: OrderService[];
}

const defaultService = {
  serviceName: "",
  unit: "单位",
  count: "",
  editable: false,
};

export interface Option {
  label: string;
  value: string;
}
const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}
const StepFour = ({
  onCancel,
  onOk,
  productData,
  defaultValues,
}: fourProps) => {
  const [serviceForm, setServiceForm] = useState<OrderService[]>([]);
  const [serviceDictionary, setServiceDictionary] = useState<Option[]>([]);

  useEffect(() => {
    (async function () {
      if (defaultValues && defaultValues.length > 0) {
        setServiceForm(defaultValues);
      } else {
        if (productData.length > 0) {
          const newData: any[] = [];

          for (let i = 0; i < productData.length; i++) {
            const serviceData = {
              code: i + 1,
              name: `产品${i + 1}-${productData[i].productName}`,
              productCategory: productData[i].product[1],
              productId: productData[i].product[2],
              serviceData: [],
            };
            if (
              productData[i].product[1] === "6c2f89b5410640eaa394f8d3288709f7"
            ) {
              const resp = await instance.post(`/wf/form/vsheet/rpc`, {
                method: "getProductServiceDetail",
                workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
                paramsJson: JSON.stringify({ uuid: productData[i].product[2] }),
              });
              if (resp.data.Status === "1") {
                const data = resp.data.Data;
                serviceData.serviceData = data.map(
                  (item: { id: string; quantity: string }) => ({
                    ...item,
                    id: [item.id],
                    quantity: item.quantity + "",
                  })
                );
              }
            }
            newData[i] = serviceData;
          }
          setServiceForm(newData);
        }
      }
    })();
  }, [productData, defaultValues]);

  useEffect(() => {
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=psi_service&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setServiceDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
  }, []);
  const addService = useCallback(
    (index) => {
      const copy = JSON.parse(JSON.stringify(serviceForm));
      copy[index].serviceData.push(defaultService);
      setServiceForm(copy);
    },
    [serviceForm]
  );

  return (
    <>
      <NavBar
        className="orderNavBar"
        icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <div className="mt45"></div>
      {serviceForm.length > 0 &&
        serviceForm.map((item, index) => (
          <Fragment key={"service" + index}>
            <List className="serviceWrapper">
              <Flex
                justify="between"
                style={{ background: "#f2f2f2", padding: "10px 20px" }}>
                <Flex.Item>{item.name}</Flex.Item>
                {item.productCategory ===
                  "6c2f89b5410640eaa394f8d3288709f7" && (
                  <Flex.Item
                    style={{ textAlign: "right", color: "#169BD5" }}
                    onClick={() => {
                      let copy = JSON.parse(JSON.stringify(serviceForm));
                      copy[index].serviceData = copy[index].serviceData.map(
                        (copyItem: any) => ({
                          ...copyItem,
                          editable: !copyItem.editable,
                        })
                      );
                      setServiceForm(copy);
                    }}>
                    {item.serviceData[0].editable ? "完成" : "编辑"}
                  </Flex.Item>
                )}
              </Flex>
              {item.serviceData.length > 0 &&
                item.serviceData.map((childrenItem, i) => (
                  <Fragment key={"parentService" + i}>
                    <Picker
                      data={serviceDictionary}
                      cols={1}
                      value={childrenItem.id}
                      disabled={childrenItem.editable}
                      onChange={async (value: any) => {
                        let copy = JSON.parse(JSON.stringify(serviceForm));
                        copy[index].serviceData[i].id = value;
                        const resp = await instance.post(
                          `/wf/form/vsheet/loadRelated`,
                          {
                            request: JSON.stringify({
                              dataSourceTableName: "psi_service",
                              requestFieldMaps: [
                                {
                                  vSheetFieldName: "产品服务明细_服务名称",
                                  dataSourceFieldName: "uuid",
                                  value: value[0],
                                },
                              ],
                              resultFieldMaps: [
                                {
                                  vSheetFieldName: "产品服务明细_规格",
                                  dataSourceFieldName: "spec",
                                },
                              ],
                            }),
                          }
                        );
                        copy[index].serviceData[i].spec =
                          resp.data.Data.resultFieldMaps[0].value;
                        setServiceForm(copy);
                      }}>
                      <List.Item arrow="horizontal">
                        {childrenItem.editable ? (
                          <Icon
                            type="cross-circle-o"
                            size="xxs"
                            style={{ color: "#aaa" }}
                            onClick={(e) => {
                              let copy = JSON.parse(
                                JSON.stringify(serviceForm)
                              );
                              copy[index].serviceData.splice(i, 1);
                              setServiceForm(copy);
                              e.stopPropagation();
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </List.Item>
                    </Picker>
                    <InputItem
                      placeholder="请输入"
                      value={childrenItem.quantity}
                      type="money"
                      moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                      editable={!childrenItem.editable}
                      onChange={(value) => {
                        let copy = JSON.parse(JSON.stringify(serviceForm));
                        copy[index].serviceData[i].quantity = formatRoundNumber(
                          value
                        );
                        setServiceForm(copy);
                      }}
                      extra={childrenItem.spec}>
                      {""}
                    </InputItem>
                  </Fragment>
                ))}
              {item.productCategory === "6c2f89b5410640eaa394f8d3288709f7" &&
                !item.serviceData[0].editable && (
                  <>
                    <div className="space"></div>
                    <div
                      className="addShopBtn"
                      onClick={() => addService(index)}>
                      + 添加服务
                    </div>
                    <div className="space"></div>
                  </>
                )}
            </List>
          </Fragment>
        ))}
      <div className="mb100"></div>
      <Flex style={bottomBtnStyle}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onOk?.(serviceForm)}>
            下一步
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default StepFour;
